<div *ngIf="isDevEnv" class="dev-banner">{{ 'APP.DEV_BANNER' | translate }}</div>
<ng-container *ngIf="!isStandalonePage">
  <div class="app-container">
    <app-trial-banner></app-trial-banner>
    <app-topbar [currentUser]="currentUser"
        (languageChange)="onLanguageChange($event)"></app-topbar>

    <main class="main-content">
        <!-- Nouvelle version disponible : en haut du contenu, jamais dans la barre du haut ni le dock -->
        <app-banniere-mise-a-jour></app-banniere-mise-a-jour>
        <router-outlet></router-outlet>
    </main>

    <!-- Trial Countdown Widget (draggable) -->
    <app-trial-widget></app-trial-widget>

    <!-- Floating Action Button -->
    <div class="fab-wrapper"
         [style.left.px]="fabX"
         [style.top.px]="fabY"
         [class.dragging]="fabDragging">

      <div class="fab-btn"
           [class.open]="fabOpen"
           (mousedown)="onFabMouseDown($event)"
           (touchstart)="onFabTouchStart($event)"
           (click)="toggleFab()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
        </svg>
      </div>

      <div class="fab-menu" [class.open]="fabOpen" [class.fab-menu-edit]="fabEditMode">

        <!-- Normal mode: show shortcuts -->
        <ng-container *ngIf="!fabEditMode">
          <div class="fab-menu-head">{{ 'MENU.QUICK_ACTIONS' | translate }}</div>
          @for (qa of menuService.quickActions(); track qa.label) {
            <div class="fab-menu-item" (click)="fabNavigate(qa.routerLink!)">
              <div class="fab-menu-ic" [ngClass]="qa.gradient || 'g-indigo'">
                <i [class]="qa.icon || 'pi pi-bolt'" style="color:white;font-size:14px"></i>
              </div>
              <span>{{ qa.label | translate }}</span>
            </div>
          }
          <div class="fab-menu-sep"></div>
          <div class="fab-menu-item fab-menu-edit-btn" (click)="toggleFabEdit()">
            <div class="fab-menu-ic g-gray">
              <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" style="width:16px;height:16px;margin:6px">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </div>
            <span>{{ 'MENU.CUSTOMIZE' | translate }}</span>
          </div>
        </ng-container>

        <!-- Edit mode: show all available items grouped by section -->
        <ng-container *ngIf="fabEditMode">
          <div class="fab-menu-head fab-menu-head-edit">
            <span>{{ 'MENU.CUSTOMIZE' | translate }}</span>
            <span class="fab-menu-done" (click)="toggleFabEdit()">{{ 'MENU.DONE' | translate }}</span>
          </div>
          <div class="fab-edit-search">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input [(ngModel)]="fabEditSearch" [placeholder]="'MENU.SEARCH' | translate" autocomplete="off">
          </div>
          <div class="fab-menu-scroll">
            @for (section of filteredMenuSections; track section.label) {
              <div class="fab-menu-section-label">{{ section.label | translate }}</div>
              @for (item of section.items; track item.label) {
                @if (!item.separator && item.routerLink) {
                  <div class="fab-menu-item fab-menu-toggle-item" (click)="toggleShortcut(item.routerLink!)">
                    <div class="fab-menu-ic" [ngClass]="item.gradient || 'g-indigo'">
                      <i [class]="item.icon || 'pi pi-bolt'" style="color:white;font-size:14px"></i>
                    </div>
                    <span class="fab-menu-toggle-label">{{ item.label | translate }}</span>
                    <div class="fab-menu-check" [class.active]="isShortcut(item.routerLink!)">
                      <svg *ngIf="isShortcut(item.routerLink!)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="width:14px;height:14px">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    </div>
                  </div>
                }
              }
            }
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<router-outlet *ngIf="isStandalonePage"></router-outlet>
<p-toast position="top-right"></p-toast>
<app-confirmation-dialog></app-confirmation-dialog>
<app-confirm-dialog></app-confirm-dialog>
@if (verrou.verrouille()) {
  <app-ecran-verrou></app-ecran-verrou>
}
